"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SuspenseWrap = exports.RouteMap = void 0;
var Handlers = _interopRequireWildcard(require("../../utils/withInjectedLinkHandlers"));
var _Loading = _interopRequireDefault(require("./../Loading/Loading"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const RouteMap = _ref => {
    let {
      data,
      handleRoutes = _reactRouterDom.useRoutes
    } = _ref;
    return handleRoutes(data);
  },
  SuspenseWrap = props => {
    const {
        children,
        data,
        forceExternalDownload = false,
        forceInternalDownload = false,
        handleRoutes,
        Loader = /*#__PURE__*/_react.default.createElement(_Loading.default, null),
        ...rest
      } = props,
      WrappedComponent = Handlers.withInjectedLinkHandlers(RouteMap, {
        forceExternalDownload: forceExternalDownload,
        forceInternalDownload: forceInternalDownload
      });
    return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: Loader
    }, /*#__PURE__*/_react.default.createElement(WrappedComponent, _extends({
      data: data,
      handleRoutes: handleRoutes
    }, rest)), children);
  };

/**
 * Router Manager with suspense loading component
 *
 * @visibleName Route Manager
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.SuspenseWrap = SuspenseWrap;
exports.RouteMap = RouteMap;
const RouteManager = props => {
  const {
    basename,
    excludedPaths = [],
    ...rest
  } = props;
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.BrowserRouter, {
    basename: basename
  }, /*#__PURE__*/_react.default.createElement(SuspenseWrap, _extends({
    excludedPaths: excludedPaths
  }, rest)));
};
RouteManager.propTypes = {
  /** Basename of site */
  basename: _propTypes.default.string,
  /** @ignore */
  children: _propTypes.default.any,
  /** Array of directory exclusion RegExp patterns (Default Value: []) */
  excludedPaths: _propTypes.default.arrayOf(_propTypes.default.object),
  /** Array of routing data */
  data: _propTypes.default.array,
  /** @ignore */
  handleRoutes: _propTypes.default.func,
  /** Loading component */
  Loader: _propTypes.default.elementType
};

// Export component as default;
var _default = exports.default = RouteManager;